export enum ModeOfTransport {
  OCEAN = 'OCEAN',
  AIR = 'AIR',
  RAIL = 'RAIL',
  TRUCK = 'TRUCK',
}
